import {
  type IMCAttributionWindowDays,
  type INBAccountingMode,
} from "@north-beam/nb-common";

import { type SalesMetricV2 } from "../types";

export function makeAvgTouchpointsPerOrder({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "avgTouchpointsPerOrder";

  return {
    id,
    name: "Touchpoints",
    fullName:
      "Touchpoints / All" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description:
      "Average length of the customer journey across orders included in revenue.",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeAvgTouchpointsPerOrderLtv(): SalesMetricV2 {
  const id = "avgTouchpointsPerOrderLtv";

  return {
    id,
    name: "Touchpoints (∞)",
    fullName: "Touchpoints / All (∞)",
    description:
      "Average length of the customer journey across orders included in revenue.",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isLtv: true,
    isDashboardV2: true,
  };
}
